module.exports = __webpack_public_path__ + "img/withard-finish.b2126f96.svg";